// 動態 meta 管理：路由切換時呼叫 setMeta(to.meta) 即可

const DEFAULTS = {
  title: 'M4ORE SPORT 摩爾運動 | 運動防護工作室與 SportApp 管理平台',
  description: 'M4ORE SPORT（摩爾運動）為摩爾資通旗下運動科技品牌，2023 年成立。提供運動傷害處置、運動按摩、體適能檢測、運動訓練與運動防護等工作室服務，並開發 SportApp 組織級運動防護管理平台。',
  keywords: 'M4ORE SPORT, 摩爾運動, 運動防護, 運動傷害處置, 運動按摩, 體適能檢測, SportApp',
  ogImage: 'https://sport.m4ore.com/m4ore.ico',
  canonical: 'https://sport.m4ore.com/'
};

function upsertMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const m = selector.match(/\[(.+?)="(.+?)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setMeta(meta = {}) {
  const m = { ...DEFAULTS, ...meta };

  document.title = m.title;

  upsertMeta('meta[name="description"]', 'content', m.description);
  upsertMeta('meta[name="keywords"]', 'content', m.keywords);

  upsertMeta('meta[property="og:title"]', 'content', m.title);
  upsertMeta('meta[property="og:description"]', 'content', m.description);
  upsertMeta('meta[property="og:image"]', 'content', m.ogImage);
  upsertMeta('meta[property="og:url"]', 'content', m.canonical);

  upsertMeta('meta[name="twitter:title"]', 'content', m.title);
  upsertMeta('meta[name="twitter:description"]', 'content', m.description);
  upsertMeta('meta[name="twitter:image"]', 'content', m.ogImage);

  upsertLink('canonical', m.canonical);
}
